import { useAuth } from '../hooks/useAuth'

// brand_admin view (decided Oct 2026): a planning-focused UI. Pages, tabs and buttons are hidden, never deleted;
// super_admin / brand_super_admin see everything. Uses the effective role, so the "View as brand_admin" toggle works.
export function useIsBrandAdmin() {
  const { profile } = useAuth()
  return profile?.role === 'brand_admin'
}

// Landing page for brand_admins (Dashboard is hidden). The Planner only exists for Bloomi so far.
export function brandAdminHome(brand) {
  return brand?.slug === 'bloomi' ? '/planner' : '/inventory'
}
